<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <PageHeader title="Export Bookmarks" />

    <ExportBookmark />

    <v-card class="mt-4">
      <v-card-title>
        <v-icon left>mdi-help-circle</v-icon>
        Need Help?
      </v-card-title>
      <v-card-text>
        <p class="mb-3">
          Learn how to export bookmarks from your browser and import them into
          LinkBook.io, or export LinkBook.io bookmarks back to your browser.
        </p>
        <v-btn color="info" outlined to="/bookmark-guide">
          <v-icon left>mdi-book-open-variant</v-icon>
          View Complete Guide
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import ExportBookmark from '@/components/utils/ExportBookmark'

export default {
  name: 'BookmarkExport',
  components: {
    PageHeader,
    ExportBookmark
  },
  metaInfo: {
    title: 'Export Bookmarks | Download Browser Bookmarks',
    titleTemplate: '%s - LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'Export your LinkBook.io bookmarks as an HTML file for use in other browsers or bookmark services. Create backups of your bookmarks.'
      },
      {
        name: 'keywords',
        content:
          'export bookmarks, download bookmarks, backup bookmarks, HTML bookmark file, browser bookmark export'
      }
    ]
  }
}
</script>
